export const athenaRed = '#fc5c65';
export const athenaGreyBG = '#f2f3f7';
export const athenaGrey = '#333333';
export const athenaLightGrey = '#BBBBBB';
export const athenaBlue = '#00a8d7';
export const athenaGreen = '#32c77f';
// export const athenaBlueDark = '#007cc2';
export const statGrey = '#7e7e7e';
export const statGreen = '#38ada9';
export const statOrange = '#fca325';
export const statRed = '#fc5c65';
export const gradientBlue = 'linear-gradient(135deg, #00a8d7, #00c1e4)';

export const API_PERMISSIONS = {
  '/': 'athena.view_substep',
  '/parthenos/': 'parthenos.view_weekly_cockpit',
  '/parthenos/supply': 'parthenos.view_supply',
  '/parthenos/demand': 'parthenos.view_demand',
  '/parthenos/inventory': 'parthenos.view_inventory',
  '/cockpits/': 'athena.view_key_results',
  '/cockpits/demand-map': 'athena.view_demand_map',
  '/cockpits/supply-map': 'athena.view_supply_map',
  '/scenarios/comparison': 'athena.view_scenario',
  '/scenarios/create': 'athena.add_scenario',
  '/scenarios/:id/detail': 'athena.view_scenario',
  '/scenarios/:id/edit': 'athena.change_scenario',
  '/demand/': 'athena.view_demand_overview',
  '/demand/detail': 'athena.view_demand_detail',
  '/demand/bridges': 'athena.view_demand_bridges',
  '/supply/technology': 'athena.view_technology_dashboard',
  '/supply/fg-sfg': 'athena.view_fg_sfg_supply',
  '/supply/detail': 'athena.view_supply_detail',
  '/raw-and-packs/': 'athena.view_raw_packs',
  '/raw-and-packs/commitment': 'athena.view_raw_packs_commitment',
  '/raw-and-packs/bom': 'athena.view_raw_packs_bom',
  '/performance-monitoring/demand': 'athena.view_performance_monitoring_demand',
  '/performance-monitoring/supply': 'athena.view_performance_monitoring_supply',
  '/help': 'athena.view_glossaryentry',
};

export const VIEWS_TITLES = {
  '/': 'Cycle workflow',
  '/parthenos/': 'Weekly cockpit',
  '/parthenos/supply': 'Supply',
  '/parthenos/demand': 'Demand',
  '/parthenos/inventory': 'Inventory',
  '/cockpits/': 'Key results',
  '/cockpits/demand-map': 'Demand map',
  '/cockpits/supply-map': 'Supply map',
  '/input-files/': 'Input Files',
  '/scenarios/': 'Scenarios',
  '/demand/': 'Demand overview',
  '/demand/detail': 'Demand Detail',
  '/demand/bridges': 'Demand Bridges',
  '/supply/technology': 'Technology Dashboard',
  '/supply/fg-sfg': 'FG/SFG Supply',
  '/supply/detail': 'Supply Detail',
  '/raw-and-packs/': 'Raw & Packs Overview',
  '/raw-and-packs/commitment': 'Raw & Packs Commitment',
  '/raw-and-packs/bom': 'Raw & Packs BOM',
  '/performance-monitoring/demand': 'Performance Monitoring - Demand',
  '/performance-monitoring/supply': 'Performance Monitoring - Supply',
  '/help': 'Help',
};

export const PERFORMANCE_FORMULAS = {
  accuracy_tex : `\\textrm{accuracy}_{(granularity, MTH)} = 
  1 - \\textrm{min}\\left( 1, 
    \\frac{\\sum_{(SKU, CBU)\\in granularity}\\lvert\\textrm{forecasts}_{(SKU, CBU, MTH)} - \\textrm{actuals}_{(SKU, CBU MTH)}\\rvert}
          {\\sum_{(SKU, CBU)\\in granularity}\\lvert\\textrm{actuals}_{(SKU, CBU, MTH)}\\rvert}
  \\right)`,
  bias_tex : `\\textrm{bias}_{(granularity, MTH)} =
    \\frac{\\sum_{(SKU, CBU)\\in granularity}\\left(\\textrm{forecasts}_{(SKU, CBU, MTH)} - \\textrm{actuals}_{(SKU, CBU, MTH)}\\right)}
          {\\sum_{(SKU, CBU)\\in granularity}\\textrm{actuals}_{(SKU, CBU, MTH)}}`,

  m3_bias_tex : `\\textrm{3M-bias}_{(granularity, MTH)} =
  \\frac{\\sum_{(SKU, CBU)\\in granularity}\\sum_{m=0}^{2}\\left(\\textrm{forecasts}_{(SKU, CBU, MTH-m)} - \\textrm{actuals}_{(SKU, CBU, MTH-m)}\\right)}
        {\\sum_{(SKU, CBU)\\in granularity}\\sum_{m=0}^{2}\\textrm{actuals}_{(SKU, CBU, MTH-m)}}`,
}


export const ATHENA_VERSION = '3.4.1'
